export const UPDATE_OPEN_POSITION_CANCELLATIONS =
  'UPDATE_OPEN_POSITION_CANCELLATIONS';

export const RESET_OPEN_POSITIONS_CANCELLATIONS =
  'RESET_OPEN_POSITIONS_CANCELLATIONS';
